module.exports = __webpack_public_path__ + "static/img/poster3.7229761.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poster3.jpg
// module id = CXIU
// module chunks = 1